<template>
    <div id="abnormal-data-info">
      <div class="title">
        <span>异常数据</span>
        <dv-decoration-2 style="height:10px;" />
      </div>
      <div class="details">
        <dv-scroll-board :config="config" />
      </div>
    </div>
</template>

<script>
    let config = {};

    export default {
      name: "AbnormalData",
      data(){
        return{
          config
        }
      },
      methods: {
        createData(){
          let streetId = localStorage.getItem("streetId")
          if (!streetId) {
            streetId = JSON.parse(localStorage.getItem("USER")).streetId;
          }
          let params = {streetId: streetId};
          this.$get('/data/showAbnormalData',{
            ...params
          }).then((r)=>{
            let data = r.data;
            if(data.code != 200){
              this.$message.error("权限不足");
            }else {
              let abnormal = new Array();
              data.data.forEach(d=>{
                let user = new Array();
                user.push(d.name);
                user.push(d.doorNo);
                abnormal.push(user);
              });

              this.config = {
                header: ['姓名', '异常地点'],
                data: abnormal,
                align: ['left','left'],
                columnWidth: [130],
                rowNum: 8,
                waitTime: 2500,
                headerBGC: '#1981f6',
                headerHeight: 30,
                oddRowBGC: 'rgba(0, 44, 81, 0.8)',
                evenRowBGC: 'rgba(10, 29, 50, 0.8)'
              };

            }
          }).catch(()=>{

          })
        }
      },
      mounted() {
        const {createData} = this;
        createData();
        const timer = setInterval(createData, 300000);
        this.$once('hook:beforeDestroy',function () {
          clearInterval(timer);
        });

      }
    }
</script>

<style lang="less" scoped>
  #abnormal-data-info{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 10px;
    cursor: pointer;

    .title{
      width: 100%;
      text-align: center;
      font-size: 1.1em;
      color: #ffffff;
    }

    .details{
      width: 100%;
      height: 90%;
      padding-bottom: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/datav/AbnormalData.vue